import React from 'react'

import { Tertiary as Button } from '@cinch/oxd-components/button/src'

const CompareToggle: React.FC<any> = ({ ...props }) => {
  return (
    <Button size={'mini'} {...props}>
      Remove Car
    </Button>
  )
}

export default CompareToggle
